import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger';
  size?: 'sm' | 'md' | 'lg';
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-mono text-xs uppercase tracking-widest transition-colors duration-300 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-primary text-primary-foreground hover:bg-primary/90',
    secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
    outline: 'border border-border bg-transparent hover:border-primary hover:text-primary',
    ghost: 'bg-transparent hover:bg-secondary text-muted-foreground hover:text-foreground',
    danger: 'bg-destructive text-destructive-foreground hover:bg-destructive/90'
  };
  const sizes = {
    sm: 'h-8 px-3 py-1.5',
    md: 'h-10 px-5 py-2.5',
    lg: 'h-12 px-8 py-3'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-474">
      {children}
    </button>;
}